import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { PermissionService } from './services/permission.service';
import {
  accessIdForPath,
  buildNavGroupsForPortal,
  type AccessAction,
  type SidebarPortal,
} from './constants/sidebar-access';

@Injectable()
export class SidebarAccessGuard implements CanActivateChild {
  constructor(
    private authService: AuthService,
    private permissions: PermissionService,
    private router: Router,
  ) {}

  canActivateChild(child: ActivatedRouteSnapshot): boolean {
    const path = child.routeConfig?.path || '';
    const accessId = accessIdForPath(path);
    if (!accessId) {
      return true;
    }

    const action: AccessAction = /\/new$/.test(path) || path.endsWith('/new')
      ? 'add'
      : /\/edit$/.test(path)
        ? 'edit'
        : 'view';

    if (this.permissions.can(accessId, action)) {
      return true;
    }

    const parent = child.parent;
    const portal: SidebarPortal = parent?.data['supervisorPortal']
      ? 'supervisor'
      : parent?.data['teacherPortal']
        ? 'teacher'
        : 'admin';
    const user = this.authService.getUser();
    const base = portal === 'teacher' ? '/teacher' : portal === 'supervisor' ? '/supervisor' : '/main';
    const firstRoute = buildNavGroupsForPortal(portal, user?.sidebarAccess)[0]?.items[0]?.route
      ?.replace(/^\.\//, '');
    if (firstRoute && accessIdForPath(firstRoute) !== accessId) {
      void this.router.navigate([`${base}/${firstRoute}`]);
    }
    return false;
  }
}
